import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Badge, Col, Row } from 'react-bootstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useLocation, useNavigate } from 'react-router-dom';
const getAuthToken = () => {
  const userData = sessionStorage.getItem("userData");
  if (!userData) return "";
  try {
    const parsed = JSON.parse(userData);
    return parsed.token || "";
  } catch {
    return "";
  }
};
const ProceedCheckout = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    country: '',
    city: '',
    street: '',
    state: '',
    postalCode: '',
    note: '',
    paymentMethod: "Cash-on Delivery",
  });
  const location = useLocation();
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [discountCode, setDiscountCode] = useState('');
  const [appliedDiscount, setAppliedDiscount] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deliveryAddresses, setDeliveryAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [isAddingNew, setIsAddingNew] = useState(false);
  const navigate = useNavigate();
  const [coupons, setCoupons] = useState([]);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    if (location.state) {
      const { appliedCoupon, discountAmount, discountCode } = location.state;

      if (appliedCoupon) {
        setAppliedCoupon(appliedCoupon);
        setDiscountAmount(discountAmount || 0);
        setDiscountCode(discountCode || appliedCoupon.code);
      }
    }
  }, [location.state]);

    const fetchCustomer = async () => {
      const token = getAuthToken();
      if (!token) return;

      try {
        const res = await axios.get("https://vantara.datacubeglobal.com/api/show-customer", {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (res.data.status === "success") {
          const cust = res.data.data;
          setCustomer(cust);

          // set delivery addresses
          setDeliveryAddresses(cust.delivery_address || []);

          // find default address
          const defaultAddr = cust.delivery_address?.find(addr => addr.is_default === 1);

          if (defaultAddr) {
            setSelectedAddressId(defaultAddr.address_id);
            setFormData(prev => ({
              ...prev,
              phone: defaultAddr.phone || cust.phone || '',
              email: defaultAddr.email || cust.email || '',
              street: defaultAddr.address_line1 || '',
              city: defaultAddr.city || '',
              state: defaultAddr.state || '',
              postalCode: defaultAddr.postal_code || '',
              country: defaultAddr.country || ''
            }));
          }
        }
      } catch (err) {
        console.error("Error fetching customer:", err);
      }
    };
  useEffect(() => {
    fetchCustomer();
  }, []);
  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const res = await axios.get("https://vantara.datacubeglobal.com/api/get-coupons");
        if (res.data.status === "success") {
          setCoupons(res.data.coupons);
        }
      } catch (err) {
        console.error("Error fetching coupons:", err);
      }
    };
    fetchCoupons();
  }, []);



  const fetchDeliveryAddresses = async () => {
    const token = getAuthToken();
    if (!token) return;

    try {
      const res = await axios.get("https://vantara.datacubeglobal.com/api/delivery-address", {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.status === "success") {
        // Find only default address
        const defaultAddr = res.data.data.find(addr => addr.is_default === 1);

        if (defaultAddr) {
          setDeliveryAddresses([defaultAddr]); // keep only default
          setSelectedAddressId(defaultAddr.id);
          setFormData(prev => ({
            ...prev,
            phone: defaultAddr.phone || '',
            email: defaultAddr.email || '',
            street: defaultAddr.address_line1 || '',
            city: defaultAddr.city || '',
            state: defaultAddr.state || '',
            postalCode: defaultAddr.postal_code || '',
            country: defaultAddr.country || ''
          }));
        } else {
          setDeliveryAddresses([]); // no default found
        }
      }
    } catch (err) {
      console.error("Error fetching delivery addresses:", err);
    }
  };
  useEffect(() => {
    fetchDeliveryAddresses();
  }, []);


  const fetchCart = async () => {
    const token = getAuthToken();

    if (!token) {
      console.warn("No auth token found, user may need to login.");
      setCartItems([]);
      return;
    }

    try {
      const res = await axios.get("https://vantara.datacubeglobal.com/api/cart", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status === "success") {
        const items = res.data.data.map((item) => {
          const imagePath = item.product?.primary_image?.image_path;
          const imageUrl = imagePath
            ? `https://vantara.datacubeglobal.com/storage/${imagePath}`
            : "https://via.placeholder.com/70"; // fallback image


          return {
            id: item.cart_id,
            product_id: item.product_id,
            name: item.product.product_name,
            price: parseFloat(item.product.special_price),
            quantity: item.quantity,
            total: parseFloat(item.product.special_price) * item.quantity,
            image: imageUrl,
          };
        });

        setCartItems(items);
      }
    } catch (err) {
      console.error("Error fetching cart:", err);
    }
  };

  useEffect(() => {
    fetchCart();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePaymentChange = (e) => {
    setFormData(prev => ({ ...prev, paymentMethod: e.target.value }));
  };

  // const applyDiscount = () => {
  //   // Simulate applying discount code
  //   if (discountCode === 'MO234231') {
  //     setAppliedDiscount({ code: 'MO234231', amount: '10% OFF' });
  //   } else {
  //     alert('Invalid discount code');
  //   }
  // };
  const handleAddAddress = async () => {
    const token = getAuthToken();
    if (!token) return;

    const payload = {
      phone: formData.phone,
      email: formData.email,
      address_line1: formData.street,
      address_line2: '',
      city: formData.city,
      state: formData.state,
      country: formData.country,
      postal_code: formData.postalCode,
      customer_id: customer?.customer_id || 1,
      is_default: 1
    };

    try {
      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/delivery-address",
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.status === "success") {
        Swal.fire({
          icon: 'success',
          title: 'Address saved!',
          showConfirmButton: false,
          timer: 1500
        });
      //   setIsAddingNew(false);
      //   fetchCart()

      //   await fetchDeliveryAddresses();
      //   fetchCart();
      // }
     setIsAddingNew(false);
      
    await fetchCustomer()
      await fetchDeliveryAddresses(); 
      await fetchCart(); 
      
      
      setSelectedAddressId(null);
      }
    } catch (err) {
      console.error("Error adding address:", err);
      Swal.fire({
        icon: 'error',
        title: 'Failed to save address',
        text: err?.response?.data?.message || 'Please try again later',
      });
    }
  };

  const handleUpdateAddress = async (addressId) => {
    const token = getAuthToken();
    if (!token) return;

    const params = new URLSearchParams({
      phone: formData.phone,
      email: formData.email,
      address_line1: formData.street,
      address_line2: '',
      city: formData.city,
      state: formData.state,
      country: formData.country,
      postal_code: formData.postalCode,
      customer_id: customer?.customer_id || 1,
      is_default: '1'
    });

    try {
      const res = await axios.put(
        `https://vantara.datacubeglobal.com/api/delivery-address/${addressId}?${params.toString()}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.status === "success") {
        Swal.fire({
          icon: 'success',
          title: 'Address updated!',
          showConfirmButton: false,
          timer: 1500
        });
        
      setShowAddressForm(false);
      
        await fetchCustomer()
      await fetchDeliveryAddresses(); 
      await fetchCart(); 
      
      
      setSelectedAddressId(null);
      }
    } catch (err) {
      console.error("Error updating address:", err);
      Swal.fire({
        icon: 'error',
        title: 'Failed to update address',
        text: err?.response?.data?.message || 'Please try again later',
      });
    }
  };
  //   const handleDeleteAddress = async (addressId) => {
  //     const token = getAuthToken();
  //     if (!token) return;

  //     // Show confirmation modal
  //     const result = await Swal.fire({
  //       title: 'Are you sure?',
  //       text: "Do you really want to delete this address?",
  //       icon: 'warning',
  //       showCancelButton: true,
  //       confirmButtonColor: '#d33',
  //       cancelButtonColor: '#3085d6',
  //       confirmButtonText: 'Yes, delete it!',
  //       cancelButtonText: 'Cancel'
  //     });

  //     if (result.isConfirmed) {
  //       try {
  //         await axios.delete(
  //           `https://vantara.datacubeglobal.com/api/delivery-address/${addressId}`,
  //           { headers: { Authorization: `Bearer ${token}` } }
  //         );

  //         Swal.fire({
  //           icon: 'success',
  //           title: 'Address deleted!',
  //           showConfirmButton: false,
  //           timer: 1500
  //         });
  // fetchDeliveryAddresses()
  //         // Re-fetch or update state
  //         fetchCart()
  //       } catch (err) {
  //         console.error("Error deleting address:", err);
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Failed to delete address',
  //           text: err?.response?.data?.message || 'Please try again later',
  //         });
  //       }
  //     }
  //   };
  const handleDeleteAddress = async (addressId) => {
    const token = getAuthToken();
    if (!token) return;

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "Do you really want to delete this address?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    });

    if (!result.isConfirmed) return;

    try {
      const res = await axios.delete(
        `https://vantara.datacubeglobal.com/api/delivery-address/${addressId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data?.status === 'success') {
        // remove from local state immediately
        setDeliveryAddresses(prev => prev.filter(addr => (addr.address_id || addr.id) !== addressId));

        Swal.fire({
          icon: 'success',
          title: 'Address deleted!',
          showConfirmButton: false,
          timer: 1500
        });

        // re-sync with server
        await fetchDeliveryAddresses();
        fetchCart();
      } else {
        throw new Error(res.data?.message || 'Delete failed');
      }
    } catch (err) {
      console.error("Error deleting address:", err);
      Swal.fire({
        icon: 'error',
        title: 'Failed to delete address',
        text: err?.response?.data?.message || err.message || 'Please try again later',
      });
    }
  };

  const handleCheckout = async (e) => {
    e.preventDefault();
    const token = getAuthToken();
    if (!token) {
      Swal.fire("Error", "Please login to continue", "error");
      return;
    }

    try {
      setLoading(true);
      const selectedAddr = deliveryAddresses.find(a => (a.address_id || a.id) === selectedAddressId);
      const addressState = selectedAddr?.state || formData.state || "";
      const finalAmount = calculateTotal();
      const payload = {
        coupon_code: discountCode || "",
        delivery_state: addressState,
        total_amount: finalAmount,
      };

      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/cart/checkout",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.status === "success") {
        Swal.fire("Success", "Your order has been placed!", "success");
        fetchCart();
        navigate("/");
      } else {
        Swal.fire("Error", res.data.message || "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Checkout Error:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Failed to place order. Please try again.";
      Swal.fire("Error", errorMessage, "error");
    } finally {
      setLoading(false);
    }
  };


  const calculateSubtotal = () => {
    return cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
  };

  const calculateTotal = () => {
    return calculateSubtotal() - discountAmount;
  };

  // const handleApplyCoupon = (code) => {
  //   const coupon = coupons.find(c => c.code.toLowerCase() === code.toLowerCase());
  //   if (!coupon) {
  //     Swal.fire("Invalid Coupon", "This coupon code is not valid.", "error");
  //     setDiscountAmount(0);
  //     setAppliedCoupon(null);
  //     return;
  //   }

  //   const subtotal = calculateSubtotal();
  //   if (subtotal < parseFloat(coupon.min_order_amount)) {
  //     Swal.fire("Not Eligible", `Minimum order amount is ₹${coupon.min_order_amount}`, "info");
  //     return;
  //   }

  //   let discount = 0;
  //   if (coupon.type === "fixed") {
  //     discount = parseFloat(coupon.value);
  //   } else if (coupon.type === "percentage") {
  //     discount = (subtotal * parseFloat(coupon.value)) / 100;
  //   }

  //   setDiscountAmount(discount);
  //   setAppliedCoupon(coupon);
  //   Swal.fire("Success", `Coupon "${coupon.code}" applied successfully!`, "success");
  // };

  const handleApplyCoupon = async (code) => {
    if (!code) {
      Swal.fire("Enter Coupon", "Please enter a coupon code.", "warning");
      return;
    }

    const subtotal = calculateSubtotal();
    const token = getAuthToken();

    try {

      const response = await axios.post(
        "https://vantara.datacubeglobal.com/api/coupon/validate",
        {
          coupon_code: code,
          total_amount: subtotal,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = response?.data;


      if (!data || data.status === "error") {
        Swal.fire("Coupon Not Applicable", data?.message || "This coupon code is not valid.", "error");
        setDiscountAmount(0);
        setAppliedCoupon(null);
        return;
      }


      const coupon = coupons.find(c => c.code.toLowerCase() === code.toLowerCase()) || data.coupon;

      if (subtotal < parseFloat(coupon.min_order_amount || 0)) {
        Swal.fire("Not Eligible", `Minimum order amount is ₹${coupon.min_order_amount}`, "info");
        return;
      }

      let discount = 0;
      if (coupon.type === "fixed") {
        discount = parseFloat(coupon.value);
      } else if (coupon.type === "percentage") {
        discount = (subtotal * parseFloat(coupon.value)) / 100;
      }

      setDiscountAmount(discount);
      setAppliedCoupon(coupon);
      Swal.fire("Success", `Coupon "${coupon.code}" applied successfully!`, "success");

    } catch (error) {
      console.error("Error validating coupon:", error);

      const apiMessage = error?.response?.data?.message;
      Swal.fire("Error", apiMessage || "Could not validate coupon. Please try again.", "error");
      setDiscountAmount(0);
      setAppliedCoupon(null);
    }
  };

  return (
    <div className="container my-5">
      {/* Breadcrumb */}
      {/* <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a href="#" className="text-decoration-none">Homepage</a></li>
          <li className="breadcrumb-item"><a href="#" className="text-decoration-none">Shop</a></li>
          <li className="breadcrumb-item active" aria-current="page">Checkout</li>
        </ol>
      </nav> */}

      <div className="row">
        {/* Left Column: Form */}
        <div className="col-lg-6">
          <div className="bg-white rounded shadow-sm p-4 mb-4">
            <h5 className="mb-4">Contact & Address</h5>


            <div className="mb-4">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <label className="form-label mb-0">Delivery Address</label>
                <button
                  type="button"
                  className="btn btn-sm me-1"
                  style={{
                    borderColor: "#1C3F1D",
                    color: "#1C3F1D",
                    backgroundColor: "transparent",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#1C3F1D";
                    e.target.style.color = "#fff";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#1C3F1D";
                  }}
                  onClick={() => {
                    setIsAddingNew(true);
                    setShowAddressForm(true);
                    setFormData(prev => ({
                      ...prev,
                      phone: '',
                      email: '',
                      street: '',
                      city: '',
                      state: '',
                      postalCode: '',
                      country: ''
                    }));
                  }}
                >
                  + Add New
                </button>

              </div>

              {deliveryAddresses.length > 0 ? (
                <div className="border rounded p-3 mb-3">
                  {deliveryAddresses
                    .filter(addr => addr.is_default === 1)
                    .map(addr => (
                      <div key={addr.address_id} className="mb-2 p-2  rounded ">
                        <div className="d-flex justify-content-between">
                          <div>
                            <div><strong>{addr.address_line1}</strong></div>
                            <div>{addr.city}, {addr.state} {addr.postal_code}</div>
                            <div>{addr.country}</div>
                            <div className="mt-1">
                              <i className="bi bi-telephone-fill me-2"></i> {addr.phone}
                            </div>

                          </div>
                          {/* <div>
                            <button
                              className="btn btn-sm me-1"
                              style={{
                                borderColor: "#7B0046",
                                color: "#7B0046"
                              }}
                              onClick={() => {
                                setSelectedAddressId(addr.address_id);
                                setFormData(prev => ({
                                  ...prev,
                                  phone: addr.phone,
                                  email: addr.email,
                                  street: addr.address_line1,
                                  city: addr.city,
                                  state: addr.state,
                                  postalCode: addr.postal_code,
                                  country: addr.country
                                }));
                                setShowAddressForm(true);
                              }}
                            >
                              Edit
                            </button>

                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleDeleteAddress(addr.address_id)}
                            >
                              Delete
                            </button>
                          </div> */}
                          <div className="d-flex flex-column gap-2">
                            <button
                              className="btn btn-sm w-100"
                              style={{
                                borderColor: "#7B0046",
                                color: "#7B0046",
                                whiteSpace: "nowrap",
                                backgroundColor: "transparent",
                                transition: "all 0.2s",
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.backgroundColor = "#7B0046";
                                e.target.style.color = "#fff";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.backgroundColor = "transparent";
                                e.target.style.color = "#7B0046";
                              }}
                              onClick={() => {
                                setSelectedAddressId(addr.address_id);
                                setFormData(prev => ({
                                  ...prev,
                                  phone: addr.phone,
                                  email: addr.email,
                                  street: addr.address_line1,
                                  city: addr.city,
                                  state: addr.state,
                                  postalCode: addr.postal_code,
                                  country: addr.country
                                }));
                                setShowAddressForm(true);
                              }}
                            >
                              Edit
                            </button>

                            <button
                              className="btn btn-sm btn-outline-danger w-100"
                              onClick={() => handleDeleteAddress(addr.address_id)}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                        {addr.is_default === 1 && <span className="badge bg-success mt-2">Default</span>}
                      </div>
                    ))}
                </div>
              ) : (
                <div className="text-muted">No saved addresses</div>
              )}


              {/* Address Form (for add/edit) */}
              {showAddressForm && (
                <div className="border p-3 rounded">
                  <h6 className="mb-3">{isAddingNew ? "Add New Address" : "Edit Address"}</h6>

                  <input
                    // type="text"
                    className="form-control mb-2"
                    placeholder="Mobile Number *"
                    value={formData.phone}
                    onChange={(e) => setFormData(prev => ({ ...prev, phone: e.target.value }))}
                  />
                  <input
                    type="email"
                    className="form-control mb-2"
                    placeholder="Email *"
                    value={formData.email}
                    onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
                  />
                  <input
                    // type="text"
                    className="form-control mb-2"
                    placeholder="Street Address *"
                    value={formData.street}
                    onChange={(e) => setFormData(prev => ({ ...prev, street: e.target.value }))}
                  />
                  <input
                    // type="text"
                    className="form-control mb-2"
                    placeholder="City *"
                    value={formData.city}
                    onChange={(e) => setFormData(prev => ({ ...prev, city: e.target.value }))}
                  />
                  <div className="row mb-2">
                    <div className="col-6">
                      <select
                        className="form-control"
                        value={formData.state}
                        onChange={(e) => setFormData(prev => ({ ...prev, state: e.target.value }))}
                      >
                        <option value="">Select State*</option>

                        {/* States */}
                        <option value="andhra_pradesh (AP)">Andhra Pradesh (AP)</option>
                        <option value="arunachal_pradesh (AR)">Arunachal Pradesh (AR)</option>
                        <option value="assam (AS)">Assam (AS)</option>
                        <option value="bihar (BR)">Bihar (BR)</option>
                        <option value="chhattisgarh (CG)">Chhattisgarh (CG)</option>
                        <option value="goa (GA)">Goa (GA)</option>
                        <option value="gujarat (GJ)">Gujarat (GJ)</option>
                        <option value="haryana (HR)">Haryana (HR)</option>
                        <option value="himachal_pradesh (HP)">Himachal Pradesh (HP)</option>
                        <option value="jharkhand (JH)">Jharkhand (JH)</option>
                        <option value="karnataka (KA)">Karnataka (KA)</option>
                        <option value="kerala (KL)">Kerala (KL)</option>
                        <option value="madhya_pradesh (MP)">Madhya Pradesh (MP)</option>
                        <option value="maharashtra (MH)">Maharashtra (MH)</option>
                        <option value="manipur (MN)">Manipur (MN)</option>
                        <option value="meghalaya (ML)">Meghalaya (ML)</option>
                        <option value="mizoram (MZ)">Mizoram (MZ)</option>
                        <option value="nagaland (NL)">Nagaland (NL)</option>
                        <option value="odisha (OD)">Odisha (OD)</option>
                        <option value="punjab (PB)">Punjab (PB)</option>
                        <option value="rajasthan (RJ)">Rajasthan (RJ)</option>
                        <option value="sikkim (SK)">Sikkim (SK)</option>
                        <option value="tamil_nadu (TN)">Tamil Nadu (TN)</option>
                        <option value="telangana (TS)">Telangana (TS)</option>
                        <option value="tripura (TR)">Tripura (TR)</option>
                        <option value="uttar_pradesh (UP)">Uttar Pradesh (UP)</option>
                        <option value="uttarakhand (UK)">Uttarakhand (UK)</option>
                        <option value="west_bengal (WB)">West Bengal (WB)</option>
                        <option value="andaman_and_nicobar_islands (AN)">Andaman and Nicobar Islands (AN)</option>
                        <option value="chandigarh (CH)">Chandigarh (CH)</option>
                        <option value="dadra_and_nagar_haveli_and_daman_and_diu (DN)">
                          Dadra and Nagar Haveli and Daman and Diu (DN)
                        </option>
                        <option value="delhi (DL)">Delhi (DL)</option>
                        <option value="jammu_and_kashmir (JK)">Jammu and Kashmir (JK)</option>
                        <option value="ladakh (LA)">Ladakh (LA)</option>
                        <option value="lakshadweep (LD)">Lakshadweep (LD)</option>
                        <option value="puducherry (PY)">Puducherry (PY)</option>
                      </select>

                    </div>

                    <div className="col-6">
                      <input
                        // type="text"
                        className="form-control"
                        placeholder="Postal Code *"
                        value={formData.postalCode}
                        onChange={(e) => setFormData(prev => ({ ...prev, postalCode: e.target.value }))}
                      />
                    </div>
                  </div>
                  <input
                    // type="text"
                    className="form-control mb-3"
                    placeholder="Country *"
                    value={formData.country}
                    onChange={(e) => setFormData(prev => ({ ...prev, country: e.target.value }))}
                  />

                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        setShowAddressForm(false);
                        setIsAddingNew(false);
                        fetchDeliveryAddresses()
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm"
                      style={{backgroundColor: "#7B0046", color: "#FFFFFF"}}
                      onClick={() => {
                        if (isAddingNew) {
                          handleAddAddress();
                        } else {
                          handleUpdateAddress(selectedAddressId);
                        }
                      }}
                    >
                      {isAddingNew ? "Save Address" : "Update Address"}
                    </button>
                  </div>
                </div>
              )}
            </div>


            
          </div>
          {/* <div className="mb-3">
            <div className="mb-3">
              <h6 className="mb-2">Available Discounts</h6>
              <Row className="g-3">
                {coupons.length > 0 ? (
                  coupons.map((coupon) => (
                    <Col xs={12} md={6} key={coupon.id}>
                      <div className="bg-light p-3 rounded border position-relative h-100 coupon-card">
                        <div className="d-flex justify-content-between align-items-start">
                          <div>
                            <div className="small text-uppercase text-muted">Discount Code</div>
                            <div className="h6 mb-1">{coupon.code}</div>
                            <div className="small text-muted">{coupon.coupon_name}</div>
                            <div className="text-success small mt-1">
                              {coupon.type === "fixed"
                                ? `Flat ₹${coupon.value} off`
                                : `${coupon.value}% off`}
                            </div>
                          </div>
                          <button
                            className="btn btn-outline-dark btn-sm px-3 py-1"
                            onClick={() => {
                              setDiscountCode(coupon.code);
                              handleApplyCoupon(coupon.code);
                            }}
                          >
                            Use
                          </button>
                        </div>
                      </div>
                    </Col>
                  ))
                ) : (
                  <p className="text-muted">No coupons available right now.</p>
                )}
              </Row>
            </div>

            <div className="input-group mb-3">
              <input
                // type="text"
                className="form-control"
                placeholder="Add voucher discount"
                value={discountCode}

                onChange={(e) => setDiscountCode(e.target.value)}
              />
              <button className="btn " style={{
                backgroundColor: "#1C3F1D",
                color: "#FFFFFFFF"
              }}>Apply Code</button>
            </div>

          </div> */}
         <div className="mb-3">
                <div
                  className="d-flex gap-3 overflow-auto pb-2"
                  style={{
                    scrollSnapType: "x mandatory",
                    WebkitOverflowScrolling: "touch",
                  }}
                >
                  {coupons.length > 0 ? (
                    coupons.map((coupon) => (
                      <div
                        key={coupon.id}
                        className="bg-light p-3 rounded border coupon-card flex-shrink-0"
                        style={{
                          width: "220px",
                          scrollSnapAlign: "start",
                          boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-start">
                          <div>
                            <div className="small text-uppercase text-muted">Discount Code</div>
                            <div className="h6 mb-1">{coupon.code}</div>
                            <div className="small text-muted">{coupon.coupon_name}</div>
                            <div className="text-success small mt-1">
                              {coupon.type === "fixed"
                                ? `Flat ₹${coupon.value} off`
                                : `${coupon.value}% off`}
                            </div>
                          </div>
                          <button
                            className="btn btn-outline-dark btn-sm px-3 py-1"
                             onClick={() => {
                              setDiscountCode(coupon.code);
                              handleApplyCoupon(coupon.code);
                            }}
                          >
                            Use
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-muted">No coupons available right now.</p>
                  )}
                </div>
              </div>
        </div>

       
        <div className="col-lg-6">
          <div className="bg-white rounded shadow-sm p-4">
            <h5 className="mb-4">Shopping Cart</h5>
            <div className="mb-4">
              {cartItems.map(item => (
                <div
                  key={item.id}
                  className="d-flex align-items-start justify-content-between mb-3 border-bottom pb-2"
                >
                
                  <div className="d-flex align-items-start gap-2">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="img-fluid"
                      style={{ width: '60px', height: '80px', objectFit: 'cover' }}
                    />
                    <div>
                      <div className="fw-semibold">{item.name}</div>
                      {/* Show quantity × price BELOW name on mobile only */}
                      <div className="d-md-none mt-1 text-muted">
                        {item.quantity} × ₹{item.price.toFixed(2)}
                      </div>
                    </div>
                  </div>

                  {/* Show quantity × price on the RIGHT on medium screens and up */}
                  <div className="d-none d-md-block text-nowrap">
                    &nbsp;&nbsp;{item.quantity} × ₹{item.price.toFixed(2)}
                  </div>
                </div>
              ))}
            </div>

    
            <div className="mt-4  pt-3">
              <div className="d-flex justify-content-between mb-3">
                {/* <span>Shipping</span>
                <span>Free</span> */}
              </div>

              {appliedCoupon && (
                <div className="d-flex justify-content-between align-items-center mb-3 text-success">
                  <span>Coupon ({appliedCoupon.code})</span>
                  <div className="d-flex align-items-center gap-2">
                    <span>- ₹{discountAmount.toFixed(2)}</span>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      style={{ padding: '0.15rem 0.5rem' }}
                      onClick={() => {
                        setAppliedCoupon(null);    
                        setDiscountAmount(0);     
                        setDiscountCode('');         
                        sessionStorage.removeItem("appliedCoupon"); 
                        sessionStorage.removeItem("discountAmount");
                        sessionStorage.removeItem("voucherCode");
                      }}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              )}


              <div className="d-flex justify-content-between mb-3">
                <span className="fw-bold">Total</span>
                <span className='fw-bold text-danger'>₹{calculateTotal().toFixed(2)}</span>
              </div>
              <h5 className="mb-3">Choose payment Option:</h5>
            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="radio"
                name="paymentMethod"
                id="Cash-on Delivery"
                value="Cash-on Delivery"
                checked={formData.paymentMethod === 'Cash-on Delivery'}
                onChange={handlePaymentChange}
              />
              <label className="form-check-label" htmlFor="Cash-on Delivery">Cash-on Delivery</label>
            </div>
            {/* <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="radio"
                name="paymentMethod"
                id="paypal"
                value="paypal"
                checked={formData.paymentMethod === 'paypal'}
                onChange={handlePaymentChange}
              />
              <label className="form-check-label" htmlFor="paypal">PayPal</label>
            </div>
            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="radio"
                name="paymentMethod"
                id="bankTransfer"
                value="bank-transfer"
                checked={formData.paymentMethod === 'bank-transfer'}
                onChange={handlePaymentChange}
              />
              <label className="form-check-label" htmlFor="bankTransfer">Bank Transfer</label>
            </div> */}

            <button type="submit" className="btn  w-100 py-2 fw-bold rounded-pill mt-3" onClick={handleCheckout} disabled={loading} style={{
              backgroundColor: "#7B0046",
              color: "#FFFFFFFF"
            }}>
              Place Order
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProceedCheckout;